import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { CustomerClient } from "../../parentApi";

export default new CustomerClient(app_uri, axiosClient());
